import { render, staticRenderFns } from "./CategoryAndBrandUpdater.vue?vue&type=template&id=eb091b58&scoped=true&"
import script from "./CategoryAndBrandUpdater.vue?vue&type=script&lang=js&"
export * from "./CategoryAndBrandUpdater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb091b58",
  null
  
)

export default component.exports